import React from 'react'

export default function NotFoundPage() {
  return (
    <div className='w-full text-center pt-[100px] text-[24px]'>Page not found</div>
  )
}
